import React from 'react';

type PermissionDeniedNoticeProps = {
    title: string;
    description: string;
};

const PermissionDeniedNotice: React.FC<PermissionDeniedNoticeProps> = ({ title, description }) => (
    <div className="flex flex-col items-center justify-center py-16 text-center text-gray-500">
        <p className="text-lg font-medium">{title}</p>
        <p className="mt-2 text-sm">{description}</p>
    </div>
);

export default PermissionDeniedNotice;
